import $ from "jquery";
import {GooglePlaceDetails, makeAddressAutocomplete} from "./places";

$(document).ready(function () {

    // this code applies to the order form pages
    if($('.template-order-form').length === 0) {
        return;
    }

    const $address = $('#place_autocomplete');
    const addressAutoComplete = makeAddressAutocomplete($address[0]);
    $address.keydown(event => {
        // Prevent the user selecting an address with the enter key from submitting the form
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    });

    const $loginForm = $('#login-form');
    const validator = $loginForm.validate ({
        rules: {
            company_code:  {
                required: true,
            },
            first_name: {
                required: true,
            },
            last_name: {
                required: true,
            },
            email: {
                required: true,
                email: true,
            },
            address1: {
                required: true,
            },
            city: {
                required: true,
            },
            state: {
                required: true,
            },
            zipcode: {
                required: true,
            },
            shoe_type: {
                required: true,
            },
            shoe_size: {
                required: true,
            }
        },
        messages: {
            company_code: {
                required: pgettext('field error', 'Please enter company code')
            },
            first_name: {
                required: pgettext('field error', 'Please enter your first name')
            },
            last_name: {
                required: pgettext('field error', 'Please enter your last name')
            },
            email: {
                required: pgettext('field error', 'Please enter a valid email address')
            },
            address1: {
                required: pgettext('field error', 'Please enter your address')
            },
            city: {
                required: pgettext('field error', 'Please enter your city')
            },
            state: {
                required: pgettext('field error', 'Please enter your state')
            },
            zipcode: {
                required: pgettext('field error', 'Please enter your zip code')
            },
            shoe_type: {
                required: pgettext('field error', 'Please select shoe type')
            },
            shoe_size: {
                required: pgettext('field error', 'Please select shoe size')
            }
        }
    });

    function shownInputsValid() {
        let allValid = true;

        // validator.elements() only returns elements which are visible
        for (const el of validator.elements()) {
            if (!validator.element(el)) {
                allValid = false;
            }
        }

        return allValid;
    }

    $loginForm.submit(event => {
        // Revalidate all shown inputs
        validator.form();
        if (!shownInputsValid()) {
            event.preventDefault();
            return false;
        }

        // All fields are valid, either submit the form or go to the next page

        const $step = $('.form-step-active');
        if($step.hasClass('final-step')) {
            // We are on the last page, allow the submit to go through
            return;
        }

        // We are NOT on the last page; click the next button and block the submission
        event.preventDefault();
        $step.find('.btn-next').click();
        return false;
    });

    addressAutoComplete.addListener('place_changed', e => {
        // Force revalidation of the address field
        const addressValid = validator.element($address);
        if (!addressValid) {
            return;
        }

        const place = new GooglePlaceDetails(addressAutoComplete.getPlace());

        $('#address1').val(place.getStreetAddress()).change();
        $('#city_form').val(place.getCity()).change();
        $('#state_form').val(place.getStateCode()).change();
        $('#zipcode').val(place.getZipCode()).change();
    });

    //Order Form Steps Logic
    const prevBtns = document.querySelectorAll('.btn-prev');
    const nextBtns = document.querySelectorAll('.btn-next');
    const formSteps = document.querySelectorAll('.form-step');

    let formStepsNum = 0;
    nextBtns.forEach((btn) => {
        btn.addEventListener('click', () => {

            // remove all red borders
            $('input.error').removeClass('error');
            $('select.error').removeClass('error');

            if (formStepsNum === 0) {
                // check validity of all fields on this screen
                const company_code_filled = validator.element('#company_code');
                const address_valid = validator.element('#place_autocomplete');
                const first_name_valid = validator.element('#first_name');
                const last_name_valid = validator.element('#last_name');
                const email_valid = validator.element('#email');

                if (!company_code_filled) {
                    $('#company_code').addClass('error');
                }
                if (!address_valid) {
                    $address.addClass('error');
                }
                if (!first_name_valid) {
                    $('#first_name').addClass('error');
                }
                if (!last_name_valid) {
                    $('#last_name').addClass('error');
                }
                if (!email_valid) {
                    $('#email').addClass('error');
                }

                // only continue if all fields are valid
                if(shownInputsValid()) {

                    // extra step to validate the company code on the backend

                    // show progress cursor and disable next button during this step
                    $('body').css('cursor', 'progress');
                    $('.btn-next').addClass('disabled');

                    // remove ajax error message
                    $('#company_code_ajax_error').hide();

                    // do the ajax call
                    $.ajax({
                        url: '/validate_company_code',
                        data: {company_code: $('#company_code').val()},
                        success: function (data) {
                            // if it is valid, move to the next step
                            moveToNextStep();
                            return;
                        },
                        error: function (data) {
                            // invalid results return 404 with a message
                            $('#company_code_ajax_error').text(data.responseJSON.message).show();
                            $('#company_code').addClass('error');
                        },
                        complete: function () {
                            // re-enable next button and restore cursor
                            $('body').css('cursor', 'default');
                            $('.btn-next').removeClass('disabled');
                        }
                    });
                }

            }
            if (formStepsNum === 1) {
                // check validity of all fields on this screen
                const address_valid = validator.element('#address1');
                const city_form_valid = validator.element('#city_form');
                const state_valid = validator.element('#state_form');
                const zip_valid = validator.element('#zipcode');

                if (!address_valid) {
                    $('#address1').addClass('error');
                }
                if (!city_form_valid) {
                    $('#city_form').addClass('error');
                }
                if (!state_valid) {
                    $('#state_form').addClass('error');
                }
                if (!zip_valid) {
                    $('#zipcode').addClass('error');
                }

                // continue if all fields are good
                if(address_valid && city_form_valid && state_valid && zip_valid) {
                    moveToNextStep();
                    return;
                }
            }
            if (formStepsNum === 2) {
                // check validity of all fields on this screen
                const shoe_type_valid = validator.element('#shoe_type');
                const shoe_size_valid = validator.element('#shoe_size');

                if (!shoe_type_valid) {
                    $('#shoe_type').addClass('error');
                }
                if (!shoe_size_valid) {
                    $('#shoe_size').addClass('error');
                }

                // continue if all fields are good
                if(shoe_type_valid && shoe_size_valid) {
                    moveToNextStep();
                    return;
                }
            }


        });
    });

    function moveToNextStep() {
        formStepsNum++;
        updateFormSteps();
    }

    prevBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
            formStepsNum--;
            updateFormSteps();
        });
    });

    function updateFormSteps() {
        formSteps.forEach((formStep) => {
            formStep.classList.contains('form-step-active') &&
            formStep.classList.remove('form-step-active');
        });

        const $page = $(formSteps[formStepsNum]);
        $page.addClass('form-step-active');
        // Focus the first input element on the page which is not readonly
        $page.find('input:not([readonly]):first').focus();

        // show / hide different banner on the last step
        if(formStepsNum <= 2) {
            $('.welcome-header').show();
        } else {
            $('.welcome-header').hide();
        }
    }


    // On change of input elements update Step 3 confirmation screen
    $('.user_change').change(function(){
        const changed_field = $(this).attr('name');
        const changed_field_val = $(this).val();
        $('#summary_' + changed_field).text(changed_field_val);

        // toggle the optional address2 field
        if(changed_field === 'address2') {
            if(changed_field_val) {
                $('#summary_' + changed_field).show();
            } else {
                $('#summary_' + changed_field).hide();
            }
        }
    });

    $('#shoe_type').change(function() {

        const $shoe_size = $('#shoe_size');

        // get the shoe type (M / W)
        const shoe_type = $(this).val();

        // get the current shoe size
        let selected_shoe_size = $shoe_size.val();

        // clear the selected size
        $shoe_size.val('');

        // replace all the options, keeping the placeholder first option
        const placeholder = $("#shoe_size option:first-child");
        $shoe_size.empty().append(placeholder);

        // if no shoe type selected, disable the shoe size drop down
        if(!shoe_type) {
            $shoe_size.addClass('disabled');
            $shoe_size.prop('disabled', true);
        } else {
            // with a shoe size selected, enable the shoe size drop down
            $shoe_size.removeClass('disabled');
            $shoe_size.prop('disabled', false);

            // add the size options that go with the shoe type
            SHOE_SIZES_BY_TYPE[shoe_type].forEach(item => {
                $shoe_size.append($("<option></option>").attr('value', item[0]).text(item[1]));
            });

            // if the selected shoe size is still valid, set it as the value
            if ($shoe_size.find('option[value="' + selected_shoe_size + '"]').length) {
                $('#shoe_size').val(selected_shoe_size).trigger('change');
            }
        }

    });

    // on page load make sure all summary fields are updated
    $('.user_change').change();

});
